import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import RegistrasiUser from "../views/RegistrasiUser.vue";
import CheckStatus from "../views/CheckStatus.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { title: "Homepage | Azhar Egypt Indonesia" },
    component: Home,
  },
  {
    path: "/registrasi",
    name: "Registrasi-User",
    meta: { title: "Pendaftaran | Azhar Egypt Indonesia" },
    component: RegistrasiUser,
  },
  {
    path: "/check-status",
    name: "Check-Status",
    meta: { title: "Cek Status Pendaftaran | Azhar Egypt Indonesia" },
    component: CheckStatus,
  },
  {
    path: "/user/edit/:token", // :id adalah dynamic route parameter
    name: "EditProfile",
    meta: { title: "Sunting Profil | Azhar Egypt Indonesia" },
    component: () => import("@/views/EditUser.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  console.log(to);
  document.title = to.meta.title;
  next();
});

export default router;
